define(function(require) {
	// templates
	const tpl = require('civicsViews/attachments/templates/t_itv_attribute_item.hbs');
	const utils = require('civicsUtils/general_utilities');

	return Marionette.ItemView.extend({
		initialize: function (options) {
			this.model = options.model;
			this.collection = options.collection;
			this.numDisplayedAttributes = options.numDisplayedAttributes;
			this.disableFields = options.disableFields;
			this.attachment_index = options.attachment_index;
		},
		onRender: function() {
			this.$el.rhythmCivicsTooltipInit();
			this.$el.rhythmThemeInitCivics();
			this.$el.rhythmThemeInit();
		},
		template: tpl,
		className: "list-item",
		typeOfInput: function() {
			var self = this;
			switch (self.model.get('type')) {
				case 'Boolean':
					return 'checkbox';
				case 'List':
					return 'dropdown';
				case 'Timestamp':
					return 'datepicker';
				case 'Float8':
				case 'Decimal':
				case 'Short':
				case 'Integer':
				case 'Long':
				case 'Currency':
					return 'number';
				case 'Varchar':
				case 'LongVarChar':
				case 'LongVarCharSrch':
				default:
					return 'text';
			}
		},
		customAttr: function() {
			var self = this;
			switch (self.model.get('type')) {
				case 'Float8':
				case 'Decimal':
					return "data-dataType='System.Decimal'";
				case 'Short':
					return "data-dataType='System.Int16'";
				case 'Integer':
					return "data-dataType='System.Int32'";
				case 'Long':
					return "data-dataType='System.Int64'";
				case 'Timestamp':
					return "data-dataType='System.DateTime'";
				case 'Varchar':
				case 'LongVarChar':
				case 'LongVarCharSrch':
				default:
					return '';
			}
		},
		computeWidgetPositioning: function() {
			return this.numDisplayedAttributes - 2 > this.collection.indexOf(this.model) ? 'top' : null;
		},
		formatType: function() {
			var self = this;
			if (self.model.get('type') === 'Currency') {
				return "currency";
			} else if (self.model.get('type') === 'Timestamp') {
				return "datetime";

      }
    },
    computeDescription: function() {
      var self = this;
      if (self.model.get('portalDescription')){
        return self.model.get('portalDescription');
      } else if(self.model.get('description')) {
        return self.model.get('description');
      } else {
        return self.model.get('displayName');
      }
    },
    templateHelpers: function() {
      var self = this;
      return {
        attributes: self.model.toJSON(),
        numDisplayedAttributes: self.numDisplayedAttributes,
        formatType: self.formatType(),
        typeOfInput: self.typeOfInput(),
        customAttr: self.customAttr(),
        computeWidgetPositioning: function() {return self.computeWidgetPositioning();},
        trimDate: function(dateString) { return dateString == null? '' : utils.dateTimeString(dateString.trim(),null); },
        disableFields: self.disableFields,
        datepickerLabel: self.typeOfInput()==='datepicker' ? self.computeDescription()+ ' '+ i18n.t('CIVICS.COMMON.DATE'): null,
        timepickerLabel: self.typeOfInput()==='datepicker' ? self.computeDescription()+' '+ i18n.t('CIVICS.COMMON.TIME'):null,
		  computeDescription: self.computeDescription(),
		  uniqueID: this.attachment_index ? this.model.get('name') + '_' + this.attachment_index : this.model.get('name')
      };

		},
	});
});
